export const EVENT_NAME = {
  ONSCROLL: 'onScroll',
  CELLAPPEARPREFIX: 'onCellAppear_', // 卡片出现前缀
  SCROLL_TO_TOP: 'Scroll_to_top',
  TRIGGER_SCROLL_TO_TOP: 'Trigger_Scroll_to_top'
};

/**
 * 渲染组件类型
 */
export const RENDER_TYPE = {
  /** 子包 */
  SUB: 'sub',
  /** 自定义组件 */
  CUSTOM: 'custom',
};

/**
 * 渲染组件Ref类型
 */
export enum COMPONENT_REF_TYPE {
  WRAPPER,
  INSTANCE,
}

/**
* 组件吸顶
*/
export const STICKY_TYPE = {
  /** 不吸顶 （默认）*/
  0: 0,
  /** 吸顶 */
  1: 1,
};

// 主视图id
export const RootViewId = 'home-main-root';

// 通用筛选栏
export const FilterBarTempID = 'mach_pro_sailor_c_common_filter_bar_sub';
// 通用商家卡片
export const ChannelListShopCardTempID = 'mach_pro_sailor_c_channel_list_feed_shop_card_sub';
// 通用标题导航栏
export const ChannelListNavBarTempID = 'mach_pro_sailor_c_channel_list_nav_sub';
// 顶部头图
export const ChannelListHeaderImageTempID = 'mach_pro_sailor_c_channel_list_header_image_sub';
// 场景Tab
export const ChannelListScenceTabTempID = 'mach_pro_sailor_c_channel_list_header_scene_tab_sub';
// 标题组件
export const KingKongPageTitleBarTempId = 'mach_pro_sailor_c_kingkong_page_titlebar';
// 金刚组件
export const KingKongPageKingKongTempId = 'mach_pro_sailor_c_kingkong_page_kingkong';
// 通用下挂菜商卡
export const CommonShopCardWithDishesTempId = 'mach_pro_sailor_c_common_shop_card_with_dishes';
export const FeedsShopCardTempId = 'mach_pro_sailor_c_home_page_feeds_card_golden';

export const ChannelListBtnToTop = 'mach_pro_sailor_c_channel_list_footer_to_top_sub';
// 无数据兜底
export const PreheatTempID = 'mach_pro_sailor_c_area_preheat';
export const PageSkeletonTempID = 'mach_pro_sailor_c_kingkong_page_skeleton';
// 无更多数据: 无下拉更多数据时前端自动拼接
export const NoMoredataTempID = 'mach_pro_sailor_c_no_more_data_mach_custom';

// 网络状态
export const noNetworkUpdateData = 'noNetworkUpdateData';
// 核心参数请求完成事件
export const homecoreCompleteEvent = 'homecore_complete_event';
// 返回头部按钮埋点
export const backToTopBtnBid = {
  MV: 'b_sailor_c_txebl95k_mv',
  MC: 'b_sailor_c_txebl95k_mc'
};

// 导航栏默认样式
export const NavTitleBackDefaultData = {
  component_id: ChannelListNavBarTempID,
  component_properties: {
    stick_type: STICKY_TYPE[1],
    render_type: RENDER_TYPE.CUSTOM
  },
  json_data: {

  }
};

export const KingkongTitleBarDefaultData = {
  component_id: KingKongPageTitleBarTempId,
  component_properties: {
    stick_type: STICKY_TYPE[1],
    render_type: RENDER_TYPE.CUSTOM
  },
  json_data: {

  }
};
export const getKingkongCompDefaultData = (categoryInfo) => ({
  component_id: KingKongPageKingKongTempId,
  component_properties: {
    stick_type: STICKY_TYPE[1],
    render_type: RENDER_TYPE.CUSTOM
  },
  json_data: {
    categoryInfo
  }
});
/// 场景Tab默认样式
export const ScenceTabDefaultData = {
  component_id: ChannelListScenceTabTempID,
  component_properties: {
    stick_type: STICKY_TYPE[0],
    render_type: RENDER_TYPE.CUSTOM
  },
  layout_info: {},
  json_data: {
    cid: '',
    fromPage: ''
  }
};

/// 无数据兜底样式
export const PreheatItemDefaultData = {
  component_id: PreheatTempID,
  component_properties: {
    render_type: RENDER_TYPE.CUSTOM
  },
  layout_info: {},
  json_data: {
    sceneCode: 0,
    message: ''
  }
};

/**
 * 异常code码
 */
export enum HOME_PAGE_ERROR_CODE {
  PRE_PAGE_LOGIN_CODE = 201003221, // 预热页面-已登录
  PRE_PAGE_NO_LOGIN_COE = 201003222, // 预热页面-未登录
  LOGIN_CODE = 201003216, // 未开城-已登录
  NO_LOGIN_CODE = 201003217, // 未开城-未登录
  NO_SUPPLY_AREA = 201003206, // 无供给
  NO_DATA = 201003207, // 无数据
  NO_SERVICE = 201003213, // 不在服务范围：pageInfo接口在用
  LOADING = 20230505, // 加载中
}

export const HomePageEmptyImgMapping = {
  201003206: 'http://img-ap-hongkong.mykeeta.net/sailorc/d68605c40bc28693a4d073c50ab64ef19478.png',
  201003207: 'http://img-ap-hongkong.mykeeta.net/sailorc/d68605c40bc28693a4d073c50ab64ef19478.png',
  20230505: '',
};

export const HomePgaeLodaingItemData = {
  component_id: PreheatTempID,
  component_properties: {
    render_type: RENDER_TYPE.CUSTOM
  },
  layout_info: {},
  json_data: {
    sceneCode: HOME_PAGE_ERROR_CODE.LOADING, // 加载中
    message: ''
  }
};
export const PageSkeletonDefaultData = {
  component_id: PageSkeletonTempID,
  component_properties: {
    render_type: RENDER_TYPE.CUSTOM
  },
  layout_info: {},
  json_data: {

  }
};
export const FilterBarDefaultData = {
  component_id: FilterBarTempID,
  component_properties: {
    stick_type: STICKY_TYPE[0],
    render_type: RENDER_TYPE.SUB
  },
  layout_info: {},
  json_data: {

  }
};
// 首次请求接口时，加载中动画数据
export const HomePgaeFirstLoadingPageInfoData = {
  module_header: {
    component_list: [NavTitleBackDefaultData]
  }
};

export const getHomePgaeFirstLoadingShopListData = (params) => {
  const categoryInfo = params?.categoryInfo;
  return {
    module_header: {
      component_list: [
        KingkongTitleBarDefaultData,
        getKingkongCompDefaultData(categoryInfo),
        FilterBarDefaultData,
      ]
    },
    module_body: {
      component_list: []
    }
  };
};

// 子包下载失败需要降级的白名单：目前只有商家卡片
export const DegradationSubPackagesList = [
];

/**
 * 是否为全屏兜底
 * 未开城&无供给&其他异常
 * @param code
 */
export const isFullPreheat = (code: number): boolean => {
  if (code === 0) {
    return false;
  } else {
    if (code === HOME_PAGE_ERROR_CODE.LOGIN_CODE || code === HOME_PAGE_ERROR_CODE.NO_LOGIN_CODE || code === HOME_PAGE_ERROR_CODE.NO_SUPPLY_AREA) {
      // 未开城&无供给，兜底全屏
      return true;
    } else if (code === HOME_PAGE_ERROR_CODE.NO_DATA) {
      // 无数据，兜底非全屏，展示其他模块
      return false;
    } else {
      // 其他非0异常情况，兜底全屏
      return true;
    }
  }
};
